import Game, { GAMESTATES } from "../model/game";
import api from "./api";
import routes from "./apiRoutes.json";


const serverUrl = process.env.REACT_APP_GO;
const NUMBER_OF_QUESTIONS = 10;

enum MESSAGETYPE {
    BROADCAST_NUMSUB_TYPE = "BROADCAST_NUMSUB_TYPE",
    START_GAME_TYPE = "START_GAME_TYPE",
    QUESTIONS_TYPE = 'QUESTIONS_TYPE',
    ANSWER_TYPE = 'ANSWER_TYPE',
    WINNER_TYPE = 'WINNER_TYPE'
}

interface nextQuestionContent {
    hipotese_a: string,
    hipotese_b: string,
    hipotese_c: string,
    hipotese_d: string,
    id: string,
    lang_key: string,
    pergunta: string;
}

interface redisMessage {
    id: string,
    content: any,
}

interface message {
    type: MESSAGETYPE,
    body: any,
}

class RedisGame {
    gameSocket: WebSocket;
    userId: string;
    opponentId: string;
    gameState: Game;
    setGameState: Function;
    setGame: Function;
    gameChannel: string;
    waitingTime: number = 0;
    winner: string;
    questionTime: number = 0;
    answers: any;
    incrementPercentage: Function;

    sendNoAnswerTimeout: NodeJS.Timeout | undefined;

    constructor(gameId: string, userId: string, opponentId: string,
        gameState: Game, setState: Function, setGame: Function, incrementPercentage: Function) {
        this.gameChannel = gameId;
        this.gameSocket = new WebSocket(`${serverUrl}${this.gameChannel}`);
        this.opponentId = opponentId;
        this.userId = userId;
        this.setGameState = setState;
        this.setGame = setGame;
        this.gameState = gameState;
        this.winner = "";
        this.answers = undefined;
        this.incrementPercentage = incrementPercentage;
        this.gameSocket.onmessage = (event) => {
            this.handleGameMessage(event.data);
        };
    }

    parseData = (data: string): message => {
        const json: redisMessage = JSON.parse(data);
        const content: message = JSON.parse(json.content);
        return content;
    }
    createMessage = (type: MESSAGETYPE, body: string) => ({
        type: type,
        body: body,
    })

    publishMessage = (socket: WebSocket, channel: string, content: string) => {
        const message = {
            id: channel,
            content: content,
        };
        const msg = JSON.stringify(message);
        socket.send(msg);
    };

    sendAnswer = (answer: string) => {
        const content = {
            type: MESSAGETYPE.ANSWER_TYPE,
            body: answer,
            tta: performance.now() - this.questionTime,
            user: this.userId,
        };
        this.publishMessage(this.gameSocket, this.gameChannel, JSON.stringify(content));
    }

    getStartTime = (time: { timeToStart: string; extraMilliseconds: string; }) =>
        parseInt(time.timeToStart, 10) + (parseInt(time.extraMilliseconds, 10) / 1000000);

    getRedisTime = (time: { time: string; extraMilliseconds: string; responseTime: number; }) =>
        parseInt(time.time, 10) + (parseInt(time.extraMilliseconds, 10) / 1000000) + (time.responseTime / 1000);

    handleGameMessage = (data: string): void => {
        const content: message = this.parseData(data);
        const type: MESSAGETYPE = content.type;
        if (!this.setGameState)
            return;
        const setState = this.setGameState;
        switch (type) {
            case MESSAGETYPE.START_GAME_TYPE:
                if (this.gameState.state !== GAMESTATES.START_GAME)
                    return;
                api.get(routes.gameTime).then((res) => {
                    const startTime = this.getStartTime(content.body);
                    const redisTime = this.getRedisTime(res.data);
                    this.waitingTime = Math.round((startTime - redisTime) * 1000) / 1000;
                    setTimeout(() => {
                        setState(GAMESTATES.QUESTIONS);
                    }, this.waitingTime * 1000);
                    setState(GAMESTATES.GETREADY);
                },
                ).catch((err) => {
                    this.waitingTime = 5;
                    setTimeout(() => {
                        setState(GAMESTATES.QUESTIONS);
                    }, this.waitingTime * 1000);
                    setState(GAMESTATES.GETREADY);
                    return err;
                });
                break;
            case MESSAGETYPE.QUESTIONS_TYPE: {
                const nextQuestion: nextQuestionContent = content.body.nextQuestion;
                const question: string = nextQuestion.pergunta;
                const options: string[] =
                    [nextQuestion.hipotese_a, nextQuestion.hipotese_b, nextQuestion.hipotese_c, nextQuestion.hipotese_d];
                this.answers = content.body.questionAnswers;
                const timeToAnswer = content.body.timeToAnswer || 20000;
                if (!this.answers) {
                    this.questionTime = performance.now();
                    this.setGame(question, options, timeToAnswer / 1000);
                    setState(GAMESTATES.RESTART_QUESTION);
                } else {
                    setTimeout(() => {
                        this.questionTime = performance.now();
                        this.setGame(question, options, timeToAnswer / 1000);
                        setState(GAMESTATES.RESTART_QUESTION);
                    }, 3000);
                    const inc1 = this.answers[this.userId] === this.answers.correct ? 100 / NUMBER_OF_QUESTIONS : 0;
                    const inc2 = this.answers[this.opponentId] === this.answers.correct ? 100 / NUMBER_OF_QUESTIONS : 0;
                    this.incrementPercentage(inc1, inc2);

                    // this.incrementPercentage(10, 10);
                    setState(GAMESTATES.SHOW_QUESTION);
                }
            }
                break;
            case MESSAGETYPE.WINNER_TYPE: {
                setTimeout(() => {
                    setState(GAMESTATES.ENDGAME);
                }, 3000);
                this.winner = "game-result.tie";
                if (content.body.winner === this.userId)
                    this.winner = "game-result.win";
                else if (content.body.winner === this.opponentId)
                    this.winner = "game-result.lost";
                this.answers = content.body.answer;
                const inc1 = this.answers[this.userId] === this.answers.correct ? 100 / NUMBER_OF_QUESTIONS : 0;
                const inc2 = this.answers[this.opponentId] === this.answers.correct ? 100 / NUMBER_OF_QUESTIONS : 0;
                this.incrementPercentage(inc1, inc2);
                setState(GAMESTATES.SHOW_QUESTION);
            }
                break;
            default:
                break;
        }
    }

    close = () => {
        this.winner = "";
        this.answers = undefined;
        this.gameSocket.close();
    }

}


let instance: RedisGame | undefined = undefined;
const getRedisGame =
    (setGameState: Function, setGame: Function, incrementPercentage: Function): RedisGame | undefined => {
        if (instance) {
            instance.setGameState = setGameState;
            instance.setGame = setGame;
            instance.incrementPercentage = incrementPercentage;
        }
        return instance;
    };
const getRedisGameSimple = (): RedisGame | undefined => instance;

const createRedistGame =
    (gameId: string, userId: string, opponentId: string, gameState: Game,
        setState: Function, setGame: Function, incrementPercentage: Function): RedisGame => {
        if (instance)
            instance.close();
        instance = new RedisGame(gameId, userId, opponentId, gameState, setState, setGame, incrementPercentage);
        return instance;
    };

export { getRedisGame, getRedisGameSimple };
export default createRedistGame;
